/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable import/no-cycle */

import React from 'react';

import Input from '@ntuctech/devex-tangram/Input';
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';
import Box from '@ntuctech/devex-tangram/Box';

import { useAuth0 } from '../../Auth0Provider';
import FormWrapper from '../../theme/FormWrapper';
import FormElement from '../../theme/FormElement';
import FormActions from '../../theme/FormActions';
import ErrorLink from '../../theme/ErrorLink';

const gaScreenName = 'Verify Email';

const EmailErrorWithLink = ({ handleMoveToPhoneSignup }) => (
  <span>
    <Box displayBox="inline" mr={0.5}>
      This email doesn’t match your mobile number. Try a different email or
    </Box>
    <ErrorLink href="#" onClick={handleMoveToPhoneSignup} size="s" data-testid="inputError-signUp">
      create a new account
    </ErrorLink>
    .
  </span>
);

const VerifyEmailForm = (props) => {
  const { trackPwl } = useAuth0();
  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    isValid,
    dirty,
    isSubmitting,
    submitForm,
    handleMoveToPhoneSignup,
    emailMatchRecords,
  } = props;

  const { email } = values;

  const gaRef = React.useRef({});

  const showErrorFor = (fieldName) => touched[fieldName] && errors[fieldName];

  let emailError = showErrorFor('email');

  // const emailMatchFailed = status && status.emailMatched && status.emailMatched[email] === false;
  const emailMatchFailed = emailMatchRecords[email] === false;
  if (emailMatchFailed) {
    emailError = <EmailErrorWithLink handleMoveToPhoneSignup={handleMoveToPhoneSignup} />;
  }

  const isSubmitButtonDisabled = !dirty || !isValid || Boolean(emailError);

  const handleKeyPress = React.useCallback(
    (event) => {
      if (event.key === 'Enter' && !isSubmitButtonDisabled) {
        event.target.blur();
        submitForm();
      }
    },
    [submitForm, isSubmitButtonDisabled],
  );

  const handleEmailChange = React.useCallback(
    (e) => {
      const shouldTrackEmailTypeAfterError =
        Object.keys(emailMatchRecords).length && !gaRef.current.emailTypeTrackedAfterMatchFailed;

      if (!gaRef.current.emailTypeTracked) {
        // first time tracking
        trackPwl({
          screen_name: gaScreenName,
          event_action: 'Fill In',
          event_label: 'SignIn_Verify_Email_Initiated',
        });

        gaRef.current.emailTypeTracked = true;
      } else if (shouldTrackEmailTypeAfterError) {
        // after error tracking
        trackPwl({
          screen_name: gaScreenName,
          event_action: 'Fill In',
          event_label: 'SignIn_Error_Email_Change',
        });
        gaRef.current.emailTypeTrackedAfterMatchFailed = true;
      }

      handleChange(e);
    },
    [handleChange, emailMatchRecords, trackPwl],
  );

  return (
    <FormWrapper>
      <FormElement>
        <Input
          id="verifyInputEmail"
          data-testid="verifyInputEmail"
          type="email"
          name="email"
          label="Email"
          value={email}
          helpText={emailError}
          error={Boolean(emailError)}
          onChange={handleEmailChange}
          onBlur={handleBlur}
          onKeyPress={handleKeyPress}
          required
          fullWidth
          autoComplete="username"
        />
      </FormElement>
      <FormActions>
        <ButtonContained
          data-testid="verifyEmailButtonSubmit"
          fullWidth
          compact
          disabled={isSubmitButtonDisabled}
          loading={isSubmitting}
          onClick={submitForm}
        >
          Submit
        </ButtonContained>
      </FormActions>
    </FormWrapper>
  );
};

export default VerifyEmailForm;
